<template lang='pug'>
  b-row
    b-col(xs='12')
      b-card
        div(slot="header")
          b-row
            b-col(xs='10')
              strong {{ tableTitle }}
              small.pl-2 Collection
            c-create-entity(
              :entity='entity'
              :newEntityBtn='newEntityBtn'
              :newEntityRouteName='newEntityRouteName'
            )
        c-index-table(
          :fields='fields'
        )
</template>

<script>
  import cIndexTable from '@/components/Shared/IndexTable.vue'
  import cCreateEntity from '@/components/Shared/CreateEntity.vue'

  export default {
    name: 'UserIndex',
    components: { cIndexTable, cCreateEntity },
    data: () => {
      return {
        entity: 'user',
        tableTitle: 'Users',
        newEntityBtn: 'New user',
        newEntityRouteName: 'New user',
        fields: {
          id: { label: 'ID' },
          first_name: { label: 'First name', sortable: true },
          last_name: { label: 'Last name', sortable: true },
          email: { label: 'Email', sortable: true },
          company: { label: 'Company', sortable: true },
          role: { label: 'Role' },
          actions: { label: 'Actions' }
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/User/Index.vue